import React, { useState } from 'react';

export const CarouselPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { slides, showArrows, showIndicators } = specificAttrs || {};
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesArray = (slides || 'https://via.placeholder.com/800x400/FF6B6B,https://via.placeholder.com/800x400/4ECDC4').split(',');
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', background: '#E5E7EB' }}>
      <img
        src={slidesArray[currentSlide]?.trim() || 'https://via.placeholder.com/800x400'}
        alt={`Slide ${currentSlide + 1}`}
        style={{ width: '100%', display: 'block' }}
      />
      {showArrows !== false && (
        <>
          <button
            onClick={() => setCurrentSlide((currentSlide - 1 + slidesArray.length) % slidesArray.length)}
            style={{
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              cursor: 'pointer',
              fontSize: '18px'
            }}
          >
            ‹
          </button>
          <button
            onClick={() => setCurrentSlide((currentSlide + 1) % slidesArray.length)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(0,0,0,0.5)',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              cursor: 'pointer',
              fontSize: '18px'
            }}
          >
            ›
          </button>
        </>
      )}
      {showIndicators !== false && (
        <div style={{
          position: 'absolute',
          bottom: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '6px'
        }}>
          {slidesArray.map((_, idx) => (
            <div
              key={idx}
              onClick={() => setCurrentSlide(idx)}
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: currentSlide === idx ? '#FFFFFF' : 'rgba(255,255,255,0.5)',
                cursor: 'pointer'
              }}
            />
          ))}
        </div>
      )}
      </div>
    </div>
  );
};
